import { render, staticRenderFns } from "./AboutUsPart3.vue?vue&type=template&id=3b2e4b98&scoped=true&"
import script from "./AboutUsPart3.vue?vue&type=script&lang=js&"
export * from "./AboutUsPart3.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPart3.vue?vue&type=style&index=0&id=3b2e4b98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e4b98",
  null
  
)

export default component.exports